/**
 * Item displayed inside the dropdown select.
 */
export class DsLibMainMenuListItemInterface {
  id: number;

  name: string;
}
